// export const API_URL = "http://localhost:5050";
export const API_URL = "https://imagesgallerybackend.onrender.com";
